export const parseMediaType = (mediaType) => {
  if (mediaType.includes("gif")) return "gif";
  if (mediaType.includes("image")) return "image";
  if (mediaType.includes("video")) return "video";
};
